import { render } from "./ShopInformation.vue?vue&type=template&id=fec625ca&scoped=true"
import script from "./ShopInformation.vue?vue&type=script&lang=js"
export * from "./ShopInformation.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-fec625ca"

export default script